import * as interfaces from './Channels.Interfaces';
import { SortableHandle } from 'react-sortable-hoc';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import ChatIcon from '@material-ui/icons/Chat';
import CreateIcon from '@material-ui/icons/Create';
import DeleteIcon from '@material-ui/icons/Delete';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import IconButton from '@material-ui/core/IconButton';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import React from 'react';

const useStyles = makeStyles(theme => ({
    actions: {
        '&:hover': {
            opacity: 1,
        },
        opacity: 0,
        transition: '.25s all',
    },
    child: {
        // display:'none'
    },
    handle: {
        color: 'gray',
        marginRight: theme.spacing(2),
    },
    hover: {},
    root: {
        '&:hover + $actions': {
            opacity: 1,
        },
        listStyle: 'none',
    },
    selected: {},
}));
export function Channel({
    enabledEditMode,
    id,
    image,
    name,
    remove,
    selected,
    setChannelActive,
}: interfaces.IChannelProps) {
    const classes = useStyles();

    const handleClick = () => {
        setChannelActive(id);
    };

    const handleRemove = () => {
        remove(id);
    };
    const DragHandle = SortableHandle(() => <DragIndicatorIcon className={classes.handle} />);

    return (
        <ListItem
            button
            className="Channel-list-item"
            classes={{ root: classes.root, selected: classes.selected }}
            onClick={handleClick}
            selected={selected}
        >
            <DragHandle />
            <ListItemAvatar>
                {image ? (
                    <Avatar src={image} />
                ) : (
                    <Avatar>
                        <ChatIcon />
                    </Avatar>
                )}
            </ListItemAvatar>
            <ListItemText primary={name} />
            <ListItemSecondaryAction classes={{ root: classes.actions }}>
                <IconButton aria-label="Edit" edge="end" onClick={() => enabledEditMode(id)}>
                    <CreateIcon />
                </IconButton>
                <IconButton aria-label="Delete" edge="end" onClick={handleRemove}>
                    <DeleteIcon />
                </IconButton>
            </ListItemSecondaryAction>
        </ListItem>
    );
}

export default Channel;
